import React, { Fragment } from 'react'
import { useIntl } from 'react-intl'
import { getSurveyFrequencyDescriptionTranslation } from 'pages/surveys/utilities'
import { lowerize } from 'utilities/string'

const SurveyFrequencyDescription = ({ survey, as: Wrapper = Fragment, lowercase = false }) => {
    const { formatMessage } = useIntl()

    if(!survey.interval) {
        return null
    }

    const { values, ...translation } = getSurveyFrequencyDescriptionTranslation(survey.interval) ?? {}
    if(!Object.keys(translation).length) {
        return null
    }

    let formatted = formatMessage(translation, values)
    if(lowercase) {
        formatted = lowerize(formatted)
    }

    return (
        <Wrapper>
            {formatted}
        </Wrapper>
    )
}

export default SurveyFrequencyDescription